import React from 'react';
import {
  Box,
  Grid,
  TextField,
  Typography,
} from '@mui/material';

interface DegreeDayCustomFormProps {
  config: {
    accumulatedDegreesBaseTemp: number;
    accumulatedColdHoursBaseTemp: number;
  };
  onConfigChange: (field: string, value: string | number) => void;
}

const DegreeDayCustomForm: React.FC<DegreeDayCustomFormProps> = ({ config, onConfigChange }) => (
  <>
   <Box
      sx={{
        background: '#fff',
        borderRadius: 2,
        p: 4,
        boxShadow: 1,
        mb: 2,
        maxWidth: '100%',
      }}
    >
      <Typography variant="h5" mb={2} fontWeight="bold">Configuración Grados Día</Typography>
      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <TextField
            type="number"
            inputProps={{ step: 'any' }}
            label="Temperatura base"
            value={String(config.accumulatedDegreesBaseTemp)}
            onChange={(e) => onConfigChange('accumulatedDegreesBaseTemp', e.target.value)}
            InputProps={{
              endAdornment: <span>°C</span>,
            }}
            fullWidth
            variant="standard"
          />
        </Grid>
      </Grid>
    </Box>
    {/* Box: Horas Frío Acumuladas */}
    <Box
      sx={{
        background: '#fff',
        borderRadius: 2,
        p: 4,
        boxShadow: 1,
        mb: 2,
        maxWidth: '100%',
      }}
    >
      <Typography variant="h5" mb={2} fontWeight="bold">Configuración Serie Horas Frío</Typography>
      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <TextField
            type="number"
            inputProps={{ step: 'any' }}
            label="Temperatura base"
            value={String(config.accumulatedColdHoursBaseTemp)}
            onChange={(e) => onConfigChange('accumulatedColdHoursBaseTemp', e.target.value)}
            InputProps={{
              endAdornment: <span>°C</span>,
            }}
            fullWidth
            variant="standard"
          />
        </Grid>
      </Grid>
    </Box>
  </>
);

export default DegreeDayCustomForm;
